import { AppCriticalityEnum } from 'src/graphql/schema';

import type { AppCardData } from 'src/widgets/AppCard';
import type { IApp, IAppPolicy } from 'src/graphql/schema';

const CRITICALITY_LABEL: Record<AppCriticalityEnum, AppCardData['criticality']> = {
  [AppCriticalityEnum.Standard]: 'standard',
  [AppCriticalityEnum.Important]: 'important',
  [AppCriticalityEnum.BusinessCritical]: 'business_critical',
};

export type MappableApp = Pick<
  IApp,
  'id' | 'name' | 'criticality' | 'unclaimed' | 'owned' | 'logoUrl' | 'taskCounts'
> & {
  policy: Pick<IAppPolicy, 'update'>;
};

export const mapAppToCardData = (app: MappableApp): AppCardData => ({
  appId: app.id,
  name: app.name ?? null,
  claimed: !app.unclaimed,
  owned: app.owned,
  canManage: app.policy.update,
  criticality: app.criticality ? CRITICALITY_LABEL[app.criticality] : 'standard',
  brandLogo: app.logoUrl ?? undefined,
  extraTags: [],
  products: [],
  certificateBadges: [],
  unclaimedDetectedProduct: [],
  taskCounts: app.taskCounts,
});
